
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M8.002 1.6l5.124 2.52 1.277 5.715L10.84 14.4H5.165L1.6 9.835 2.878 4.12 8.002 1.6zM7.296.164a1.6 1.6 0 011.412 0l5.124 2.52a1.6 1.6 0 01.855 1.087l1.278 5.715a1.6 1.6 0 01-.3 1.334L12.1 15.385a1.6 1.6 0 01-1.261.615H5.165a1.6 1.6 0 01-1.261-.615L.339 10.82a1.6 1.6 0 01-.3-1.334l1.277-5.715a1.6 1.6 0 01.856-1.087L7.296.164zM4.802 8.402a3.2 3.2 0 116.401 0 3.2 3.2 0 01-6.401 0zm3.2-1.6a1.6 1.6 0 100 3.2 1.6 1.6 0 000-3.2z"}})])
          )
        }
      }
    